const defaultState = {
    logoUrl: "",
     stores: []
}

export const selectStoreModal = (state = defaultState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};